import { UserButton } from "@clerk/react";
import { Clock } from "lucide-react";
import { useApp } from "@/lib/app-context";

export default function PendingPage() {
  const { me } = useApp();
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6" data-testid="pending-page">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 fade-up">
        <div className="flex justify-between items-start">
          <div className="w-11 h-11 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><Clock size={20} /></div>
          <UserButton />
        </div>
        <h1 className="font-heading text-2xl font-extrabold mt-5">Waiting for approval</h1>
        <p className="text-sm text-slate-600 mt-2">
          You are signed in as <b>{me.email}</b>. Ask the owner to give you access from the Logins page, then refresh.
        </p>
      </div>
    </div>
  );
}
